<template>
    <v-container fluid>
        <v-data-table 
            :headers="headers"
            :items="visitRecords"
            :page.sync="pagination.current"
            :items-per-page="pagination.itemsPerPage"
            disable-pagination
            :hide-default-footer="true"
            sort-by="visiting_date"
            class="elevation-1"
        >
            <!-- 上方標頭及按鈕，加上一個資料編輯對話框 -->
            <template v-slot:top> 
                <v-toolbar flat>
                    <v-toolbar-title>拜訪紀錄</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <!-- 資料編輯對話框-->
                    <v-dialog v-model="dialog" max-width="500px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">建立新紀錄</v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-form ref="form" lazy-validation>
                                    <v-row>
                                        <v-col>
                                            <v-menu
                                                v-model="visiting_date_menu"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="auto"
                                                >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="editedItem.visiting_date"
                                                        :rules="[(v) => !!v || '請填寫拜訪日期']"
                                                        label="拜訪日期"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="editedItem.visiting_date"
                                                    @input="visiting_date_menu = false"
                                                    no-title
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-textarea
                                                v-model="editedItem.note"
                                                label="紀錄內容"
                                                :rules="[(v) => !!v || '請填寫紀錄內容']"
                                            ></v-textarea>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            {{dialogMessage}}
                                        </v-col>
                                    </v-row>
                                    </v-form>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close">取消</v-btn>
                                <v-btn color="blue darken-1" text @click="save">儲存</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialogDelete" max-width="500px">
                        <v-card>
                            <v-card-title class="headline">您確定要刪除此紀錄？</v-card-title>
                            <v-card-text>{{deleteDialogMessage}}</v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="closeDelete">取消</v-btn>
                                <v-btn color="blue darken-1" text @click="deleteItemConfirm">刪除</v-btn>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <!-- 資料表格 -->
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon large class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                <v-icon large @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="searchRecord">載入資料</v-btn>
            </template>
        </v-data-table>
        <v-pagination v-model="pagination.current" :length="pagination.total" @input="onPageChange"></v-pagination>
    </v-container>
</template>
<script>
import HolderVisitRecordDataService from '../services/HolderVisitRecordDataService'
export default {
    name: "holder-visit-record-datatable",
    props:{
        holder_id: Number
    },
    data(){
        return{
            headers:[
                {text: '日期', value:'visiting_date', width: '120px'},
                {text: '拜訪紀錄', align:'start', sortable:false, value:'note'},
                {text: '資料操作', value:'actions', sortable:false, width: '120px'}
            ],
            visitRecords:[],
            dialog:false,
            dialogDelete:false,
            visiting_date_menu:false,
            editedItem: { id:-1, holder_id: this.holder_id, visiting_date: '', note: ''},
            editedIndex: -1,
            defaultItem:{ id:-1, holder_id: this.holder_id, visiting_date: '', note: ''},
            pagination: {
                current: 1,
                total: 0,
                itemsPerPage: 20
            },
            dialogMessage: '',
            deleteDialogMessage: '',
        }
    },
    computed:{
        formTitle(){
            return this.editedIndex === -1 ? '新紀錄' : '編輯紀錄'
        },
    },
    watch:{
        dialog(val){
            val || this.close()
        },
        dialogDelete(val){
            val || this.closeDelete()
        }
    },
    created(){
        this.searchRecord()
    },
    methods:{
        close(){
            this.dialog = false
            this.$nextTick(()=>{
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },
        save(){
            if (this.$refs.form.validate()){
                if (this.editedIndex > -1){
                    //修改
                    HolderVisitRecordDataService.updateHolderVisitRecord(this.editedItem.id, this.editedItem.visiting_date, this.editedItem.note).then((response)=>{
                        if (response.result === true){
                            Object.assign(this.visitRecords[this.editedIndex], this.editedItem) 
                            this.dialogMessage=''
                            this.close()
                        } else {
                            this.dialogMessage = response.message
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                    });
                } else {
                    //新增
                    HolderVisitRecordDataService.createHolderVisitRecord(this.holder_id, this.editedItem.visiting_date, this.editedItem.note).then((response)=>{
                        if (response.result === true){
                            this.editedItem.id = response.item.id //把id 回填，以利後續更新
                            this.visitRecords.push(this.editedItem)
                            this.dialogMessage=''
                            this.close()
                        } else {
                            this.dialogMessage = response.message
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                    });
                }
            }
        },
        closeDelete(){
            this.dialogDelete = false
            this.$nextTick(()=>{
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },
        deleteItemConfirm(){
            //刪除資料邏輯
            HolderVisitRecordDataService.deleteHolderVisitRecord(this.editedItem.id).then((response)=>{
                if (response.result === true){
                    this.visitRecords.splice(this.editedIndex, 1) 
                    this.deleteDialogMessage=''
                    this.closeDelete()
                } else {
                    this.deleteDialogMessage = response.message
                }
            })
            .catch((e) => {
                console.log(e);
            });
            
        },
        editItem(item){
            console.log(item, "editItem, item")
            this.editedIndex = this.visitRecords.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },
        deleteItem(item){
            this.editedIndex = this.visitRecords.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },
        searchRecord(){
            //取得資料
            HolderVisitRecordDataService.findByCondition(this.holder_id,this.pagination.current, this.pagination.itemsPerPage).then((response) =>{ 
                if (response.result === true){
                    this.visitRecords = response.list.map(this.mapData)
                    this.pagination.total = response.last_page
                } else {
                    this.visitRecords = []
                }
            })
            .catch((e) => {
                console.log(e);
            });
            //console.log(this.visitRecords, 'searchRecord, visitRecords')
        },
        mapData(item){
            return {
                id: item.id,
                holder_id: item.holder_id,
                visiting_date: item.visiting_date,
                note: item.note
            }
        },
        onPageChange(){
            this.searchRecord();
        },
    }
}
</script>
